export default "__VITE_ASSET__CNZS0ZZT__"